import { DataGridProProps } from '@mui/x-data-grid-pro';
import { t } from 'i18next';
import { PrefilledDataConfig } from '../../../common/controllers/PaginatedTableController';
import { TlsHandshakesTableController } from '../../../common/handshakes/controllers/TlsHandshakesTableController';
import { TlsHandshake } from '../../../common/handshakes/models/TlsHandshake';
import { DefaultHeaderConfiguration } from '../../../common/types/paginated-table';
import { PaginationResult } from '../../../common/types/pagination';

type Props = {
  operationId: number;
  initialData: PaginationResult<TlsHandshake> | null;
  parentLoading: boolean;
};

export class OperationTlsHandshakesTable extends TlsHandshakesTableController<Props> {
  protected isLoading(): boolean {
    return super.isLoading() || this.props.parentLoading;
  }

  protected enableSorting(): boolean {
    return false;
  }

  protected getDefaultPageSize(): number {
    return 1;
  }

  protected getPageSizeOptions(): number[] {
    return [1];
  }

  protected getPrefilledConfig() {
    return {
      prefillActive: true,
      initialLoading: this.props.parentLoading,
      initialData: this.props.initialData,
    } as PrefilledDataConfig<TlsHandshake>;
  }

  protected getDefaultHeaderConfigurations(): DefaultHeaderConfiguration {
    return { title: t('handshakes.tlsHandshake'), hideRowCount: true };
  }

  protected getAdditionalDataGridProps(): Partial<DataGridProProps<TlsHandshake>> {
    return {
      ...super.getAdditionalDataGridProps(),
      hideFooter: true,
    };
  }
}
